import React from "react";
import { IconButton, Tooltip, useTheme } from "@mui/material";
import { motion, AnimatePresence } from "framer-motion";
import LightModeRoundedIcon from "@mui/icons-material/LightModeRounded";
import DarkModeRoundedIcon from "@mui/icons-material/DarkModeRounded";
import { useThemeMode } from "../../contexts/ThemeContext";
import { tokens } from "../../theme";

const ThemeToggle = ({ size = "medium", showTooltip = true }) => {
  const { mode, toggleTheme, isDark } = useThemeMode();
  const theme = useTheme();

  const iconVariants = {
    initial: { scale: 0, rotate: -180, opacity: 0 },
    animate: { scale: 1, rotate: 0, opacity: 1 },
    exit: { scale: 0, rotate: 180, opacity: 0 },
  };

  const buttonSx = {
    backgroundColor: isDark
      ? "rgba(255, 255, 255, 0.05)"
      : "rgba(0, 0, 0, 0.04)",
    transition: `all ${tokens.animation.durationNormal} ${tokens.animation.easeOutExpo}`,
    "&:hover": {
      backgroundColor: isDark
        ? "rgba(255, 255, 255, 0.1)"
        : "rgba(0, 0, 0, 0.08)",
      transform: "scale(1.05)",
    },
  };

  const button = (
    <IconButton
      onClick={toggleTheme}
      size={size}
      sx={buttonSx}
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
    >
      <AnimatePresence mode="wait" initial={false}>
        <motion.div
          key={mode}
          variants={iconVariants}
          initial="initial"
          animate="animate"
          exit="exit"
          transition={{
            duration: 0.3,
            ease: [0.16, 1, 0.3, 1],
          }}
          style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
        >
          {isDark ? (
            <LightModeRoundedIcon
              sx={{ color: theme.palette.warning.main }}
            />
          ) : (
            <DarkModeRoundedIcon
              sx={{ color: theme.palette.primary.main }}
            />
          )}
        </motion.div>
      </AnimatePresence>
    </IconButton>
  );

  if (showTooltip) {
    return (
      <Tooltip title={isDark ? "Light mode" : "Dark mode"} arrow>
        {button}
      </Tooltip>
    );
  }

  return button;
};

export default ThemeToggle;

